module.exports = __webpack_public_path__ + "static/media/100Jahre.6868f4d5.png";